<template>
  <div class="staff-checkin">
    <van-cell-group class="checkin-form">
      <van-field v-model.trim="name" :error="nameErr"  label="用户名" placeholder="请输入用户名" />
      <van-field v-model.trim="mobile" type="tel" pattern="[0-9]*" maxlength="11" label="手机号"  placeholder="请输入手机号" :error-message="mobileMsg" />
      <van-field v-model.trim="code" type="digit" pattern="[0-9]*" maxlength="6" center clearable label="验证码" placeholder="请输入验证码" >
        <template #button>
          <van-button size="small" type="default" @click.native="getSms" :disabled="btnDisabled">
            {{btnText}}
          </van-button>
        </template>
      </van-field>
    </van-cell-group>
    <div class="checkin-btn">
      <van-button @click="next()" :disabled="submitBtnDisabled" type="info" round block color="#0AA8AF">登录</van-button>
    </div>
  </div>
</template>

<script>
  import { volunteerLogin } from '@/api/publicWelfareStaff';
  import { SendVerifyCode } from '@/api/api';
  import { checkCellphone } from '@/utils/utils';
  import Vue from 'vue';
  import { Toast } from 'vant';

  Vue.use(Toast);
export default {
  name: "staffCheckin",
  data(){
      return{
        name:"",
        nameErr:false,
        mobile:"",
        mobileMsg:"",//手机号格式错误
        code:"",

        btnDisabled:false,
        submitBtnDisabled: false,
        btnText:'获取验证码',
        seconds: 60,
      }
  },
  computed: {},
  created() {

  },
  methods: {
      getSms() {
        let self = this;
        if (self.btnDisabled) {
          return false;
        }
        if (!self.mobile) {
          Toast('请输入手机号')
          return false;
        } else {
          if (!checkCellphone(self.mobile)) {
            Toast('手机号格式有误')
            return false;
          }
        }

        const reqData = {
          mobile: self.mobile
        };
        SendVerifyCode(reqData)
          .then((res) => {
            if (res.data.isValid) {
              Toast(res.data.resultContent)
              self.startTimer();
            } else {
              Toast(res.data.resultContent)
            }
          })
          .catch((err) => {
            Toast('手机号格式有误')
          });
      },
      startTimer() {
        this.btnDisabled = true;
        let seconds = 60;
        this.timer = setInterval(() => {
          seconds--;
          this.btnText = seconds + "秒";
          if (seconds <= 0) {
            clearInterval(this.timer);
            this.btnText = "重发验证码";
            this.btnDisabled = false;
          }
        }, 1000);
      },
      next() {
        var reg = /^\d{6}$/
        if (!this.name) {
          Toast('请输入姓名')
          return false;
        }else if (!this.mobile) {
          Toast('请输入手机号')
          return false
        } else if (!checkCellphone(this.mobile)) {
          Toast('手机号格式有误')
          return false;
        } else if (!this.code || !reg.test(this.code)) {
          Toast('验证码错误')
          return false;
        }
        this.showContract = true

        const self = this;
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        self.submitBtnDisabled = true
        volunteerLogin({
            name:self.name,
            mobile: self.mobile,
            verifycode: self.code,
          })
          .then((res) => {
            Toast.clear()
            Toast('登录成功')
            this.$store.commit("setCheckin_info", res.data);
            this.$router.replace({name:"staffMenu"})
            self.submitBtnDisabled = false
          })
          .catch((err) => {
            self.submitBtnDisabled = false
            Toast.clear()
            Toast(err.response.data.message)
          });
      }
    
  },
}
</script>

<style lang="scss" scoped>
.staff-checkin{
  min-height: 100vh;
  background-color: #F9F9F9 ;
  padding-top: 20px;
    .checkin-form {
      line-height: 20px;
      border-radius: 10px;
      text-align: center;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      margin:0 20px 50px 20px;

      background: white;
      .van-field{
        background-color:transparent;
        /deep/ .van-field__label{
          width: 4em !important;
        }
      }

      .van-button::before {
        opacity: .05;
      }
    }

    .checkin-btn {
      margin: 25px;
    }
}

</style>